<template>
  <div>
    <template v-if="enableThirdParty">
      <ThirdPartyLogin />
      <DividerSeparator />
    </template>
    <form-with-captcha
      ref="loginForm"
      :request-data="user"
      :after-captcha-verified="login"
    >
      <FieldWrapper>
        <input
          type="email"
          v-model="user.email"
          name="email"
          tabindex="1"
          placeholder="E-mail"
          v-validate="validatorDefinitions.email"
          data-vv-scope="login"
          autofocus
          autocomplete="off"
        />
      </FieldWrapper>
      <FieldWrapper>
        <input
          type="password"
          v-model="user.password"
          tabindex="1"
          name="password"
          placeholder="Password"
          v-validate="validatorDefinitions.password"
          data-vv-scope="login"
          autocomplete="off"
        />
      </FieldWrapper>

      <FieldWrapper>
        <div slot="input">
          <grid horizontal="center" vertical="middle" pair>
            <grid-item grow="1">
              <switches
                v-model="user.rememberMe"
                label="Remember me"
                theme="bulma"
                type-bold="true"
                color="blue"
              ></switches>
            </grid-item>
            <grid-item>
              <DecoratedButton
                name="login"
                @click="onSubmit"
                class="wide"
                :loading="loading"
              >
                LOG IN
              </DecoratedButton>
            </grid-item>
          </grid>
        </div>
      </FieldWrapper>
      <slot name="formBottom" />
    </form-with-captcha>
    <TwoFactorCode :show="twoFactorRequired" @close="logout" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ThirdPartyLogin from "@/components/partials/auth/ThirdPartyLogin";
import TwoFactorCode from "@/components/pages/auth/modals/twoFactor/Code";

import Switches from "@/components/partials/Switch";

import FormWithCaptcha from "@/components/partials/FormWithCaptcha";

export default {
  name: "form-login",
  props: {
    enableThirdParty: {
      type: Boolean,
      default: true
    }
  },
  components: { FormWithCaptcha, ThirdPartyLogin, TwoFactorCode, Switches },
  computed: {
    ...mapGetters("user", {
      loading: "getLoading",
      loggedInUser: "isLoggedIn",
      twoFactorRequired: "twoFactorRequired",
      activationRequired: "activationRequired",
      emailRequired: "emailRequired",
      isLocked: "isLocked"
    }),
    ...mapGetters("config", {
      recaptcha: "getRecaptcha"
    })
  },
  watch: {
    loggedInUser(loggedIn) {
      if (loggedIn) {
        this.redirectAfterLogin();
      }
    },
    activationRequired(required) {
      if (required) {
        this.$router.push({ name: this.pages.AUTH_ACTIVATION_EMAIL });
      }
    },
    emailRequired(required) {
      if (required) {
        this.$router.push({ name: this.pages.AUTH_REGISTER_COMPLETE });
      }
    },
    isLocked(value) {
      if (value) {
        this.$router.push({ name: this.pages.AUTH_LOCKED });
      }
    }
  },
  data: function() {
    return {
      user: {
        email: "",
        password: "",
        rememberMe: 1
      }
    };
  },
  methods: {
    ...mapActions("user", {
      login: "login",
      getUserData: "getUserData",
      setIsLocked: "setIsLocked",
      redirectAfterLogin: "redirectAfterLogin"
    }),
    onSubmit() {
      this.$validator.validateAll("login").then(valid => {
        if (valid) {
          this.$refs.loginForm.onSubmit();
        }
      });
    },
    logout() {
      this.services.AuthService.logout({ q: Date.now() }).then(() => {
        this.getUserData();
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
